import { render } from "./CompanyView.vue?vue&type=template&id=d2bac4cc&ts=true"
import script from "./CompanyView.vue?vue&type=script&lang=ts"
export * from "./CompanyView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Companies/CompanyView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d2bac4cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d2bac4cc', __exports__)) {
    api.reload('d2bac4cc', __exports__)
  }
  
  module.hot.accept("./CompanyView.vue?vue&type=template&id=d2bac4cc&ts=true", () => {
    api.rerender('d2bac4cc', render)
  })

}


export default __exports__